import { useMinWidth } from "./useMinWidth"

export function useBreakpoints(rules: Record<string, any>) {
  const xl = useMinWidth("xl")
  const lg = useMinWidth("lg")
  const md = useMinWidth("md")
  const sm = useMinWidth("sm")
  return {
    ...rules.xs,
    ...(sm ? rules.sm : null),
    ...(md ? rules.md : null),
    ...(lg ? rules.lg : null),
    ...(xl ? rules.xl : null),
  }
}
